import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import CLIPLogo from '../../../assets/images/clip_logo.png'
import InfoamazoniaLogo from '../../../assets/images/infoamazonia_logo.png'
import OjoPublicoLogo from '../../../assets/images/ojo_publico_logo.png'
import PulitzerLogo from '../../../assets/images/pulitzer-logo.png'
import SerrapilheiraLogo from '../../../assets/images/serrapilheira-logo.png'
import './Footer.scss'
import i18n from '../../../i18n/i18n'
import LogoMobileES from '../../../assets/images/logos/LogoCircle1_ES.svg'
import LogoMobilePT from '../../../assets/images/logos/LogoCircle1_PT.svg'
import { Divider } from '@mui/material'

export const Footer = () => {
  const { t }: any = useTranslation()
  const [isMobile, setIsMobile] = useState(
    window.matchMedia('(max-width: 768px)').matches
  )

  const findLogo = () => {
    //TODO: Refactor this
    return i18n.language === 'es' || i18n.language.includes('en')
      ? LogoMobileES
      : LogoMobilePT
  }

  return (
    <footer>
      <div className="logos-container">
        <ul>
          <li>
            <a href="https://elclip.org/" target="_blank" rel="noopener noreferrer">
              <img src={CLIPLogo} alt="CLIP Logo" />
            </a>
          </li>
          <li>
            <a href="https://infoamazonia.org/" target="_blank" rel="noopener noreferrer">
              <img
                style={{ maxWidth: '300px' }}
                src={InfoamazoniaLogo}
                alt="Infoamazonia Logo"
              />
            </a>
          </li>
          <li>
            <img src={OjoPublicoLogo} alt="Ojo Publico Logo" />
          </li>
        </ul>
        <div className="support-logos">
          <h4>{t('footer.supportOf')}</h4>

          <div>
            <img src={PulitzerLogo} alt="Pulitzer Logo" />
            <img src={SerrapilheiraLogo} alt="Serrapilheira Logo" />
          </div>
        </div>
      </div>

      <div className="credits-container">
        <div className="credits">
          <div>
            <p>
              <b>{t('footer.creditsContainer.editorialCoordination')}:</b>{' '}
              Andrés Bermúdez Liévano {t('footer.and')} Centro Latinoamericano de Investigación
              Periodística (CLIP)
            </p>
            <p>
              <b>
                {t('footer.creditsContainer.dataAndVisualizationCoordination')}:
              </b>{' '}
              Marina Gama Cubas (CLIP)
            </p>
            <p>
              <b>
                {t('footer.creditsContainer.reportingAndDataInvestigation')}:
              </b>{' '}
              Andrés Bermúdez Liévano ({t('countries.colombia')} - CLIP), Marina Gama Cubas
              ({t('countries.brasil')} - CLIP), Fábio Bispo {t('footer.and')} Schirlei Alves ({t('countries.brasil')} -
              InfoAmazonia), Aramís Castro {t('footer.and')} Gianfranco Huamán ({t('countries.peru')} - Ojo
              Público)
            </p>
            <p>
              <b>{t('footer.creditsContainer.dataProcessing')}:</b> Marina Gama
              Cubas (CLIP)
            </p>
            <p>
              <b>{t('footer.creditsContainer.production')}:</b> Luisa Fernanda
              López (CLIP)
            </p>
            <p>
              <b>{t('footer.creditsContainer.maps')}:</b> Carolina Passos
              (InfoAmazonia)
            </p>
            <p>
              <b>{t('footer.creditsContainer.graphicDesign')}:</b> Alejandra
              Saavedra López
            </p>
            <p>
              <b>
                {t(
                  'footer.creditsContainer.dataVisualizationAndWebDevelopment'
                )}
                :
              </b>{' '}
              Daniel Chinchilla Lizano {t('footer.and')} Diego Arce (CLIP)
            </p>
          </div>
        </div>
        <Divider
          sx={{ backgroundColor: '#fff' }}
          orientation={isMobile ? 'horizontal' : 'vertical'}
          flexItem
        />
        <div className="footer-description">
          <p>{t('footer.description')}</p>
        </div>
        <Divider
          sx={{ backgroundColor: '#fff' }}
          orientation={isMobile ? 'horizontal' : 'vertical'}
          flexItem
        />
        <div className="footer-logo">
          <img
            style={{ width: 165, height: 146 }}
            src={findLogo()}
            alt="Carbono Opaco"
          />
        </div>
      </div>
    </footer>
  )
}
